import { createApi } from '@reduxjs/toolkit/query/react';
import fetchQuery from '../../apiClient/fetchQuery';
import { ONEDOC_SITE_API_URL } from '../../utils/apiEndpoints';

export const onedocSiteApi = createApi({
  reducerPath: 'onedocSiteApi',
  baseQuery: fetchQuery,
  endpoints: (builder) => ({
    getOnedocSites: builder.query({
      query: ({ query = '', status = '', limit = 10, offset = 0 }) => {
        let url = `${ONEDOC_SITE_API_URL}/sites?q=${query}`;
        if (status !== 'all' && status !== '') {
          url += `&status=${status}`;
        }
        url += `&limit=${limit}`;
        url += `&offset=${offset}`;
        return {
          url,
          method: 'GET',
        };
      },
      providesTags: ['OnedocSites'],
    }),
    getOnedocSitesById: builder.query({
      query: (id) => ({
        url: `${ONEDOC_SITE_API_URL}/sites/${id}`,
        method: 'GET',
      }),
      providesTags: (result, error, id) => [{ type: 'OnedocSites', id }],
    }),
    publishSite: builder.mutation({
      query: (data) => ({
        url: `${ONEDOC_SITE_API_URL}/sites`,
        method: 'POST',
        data,
      }),
      invalidatesTags: ['OnedocSites'],
    }),
    updateSite: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `${ONEDOC_SITE_API_URL}/sites/${id}`,
        method: 'PUT',
        data,
      }),
      invalidatesTags: ['OnedocSites'],
    }),
    toggleSiteStatus: builder.mutation({
      query: ({ siteId, build_id }) => ({
        url: `${ONEDOC_SITE_API_URL}/sites/${siteId}/toggle_status`,
        method: 'PUT',
        data: build_id ? { build_id } : {},
      }),
      invalidatesTags: (result, error, { siteId }) => ['OnedocSites', { type: 'OnedocSites', id: siteId }],
    }),
    uploadIcon: builder.mutation({
      query: (formData) => ({
        url: `${ONEDOC_SITE_API_URL}/sites/media`,
        method: 'POST',
        data: formData,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }),
    }),
    getSiteBuilds: builder.query({
      query: (siteId) => ({
        url: `${ONEDOC_SITE_API_URL}/sites/${siteId}/builds`,
        method: 'GET',
      }),
      providesTags: (result, error, siteId) => [{ type: 'SiteBuilds', id: siteId }],
    }),
    checkBasePathAvailability: builder.query({
      query: (basePath) => ({
        url: `${ONEDOC_SITE_API_URL}/sites/base_path_available?query=${encodeURIComponent(basePath)}`,
        method: 'GET',
      }),
    }),
  }),
});

//q='search-term'
export const {
  useGetOnedocSitesQuery,
  useGetOnedocSitesByIdQuery, // Add this export
  usePublishSiteMutation,
  useUpdateSiteMutation,
  useToggleSiteStatusMutation,
  useUploadIconMutation,
  useGetSiteBuildsQuery,
  useCheckBasePathAvailabilityQuery,
} = onedocSiteApi;
